import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { appActions, userActions, validationActions, iamThunk } from '../../actions';
import { Validation, Intl } from '../../mixins';
import PageBoilerplateDefault from '../../components/page/PageBoilerplateDefault';
import { getRecoverableErrorType } from '../../reducers';
import { setRoute, path } from '../../router';
import { config } from '../../config';
import { hasPreviouslyLoggedIn } from '../../utils';
import {
	DNAInputWithLabel,
	DNAValidationMessage,
	DNAHeadingH1,
	DNAButtonContinue,
	DNAButtonDefault,
	Avatar,
} from '../../components';

@Validation
export class PasswordPage extends Component {
	static propTypes = {
		updateRoute: PropTypes.func,
		requestSettings: PropTypes.object.isRequired,
		passwordPageHeading1: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.string,
		]),
		isAppDisabled: PropTypes.bool,
		loginSuccessCallback: PropTypes.func,
		passwordPageContinueButtonLabel: PropTypes.string,
		globalAlertsDecoratorClass: PropTypes.string,
		password: PropTypes.string,
		emailAddress: PropTypes.string,
		firstName: PropTypes.string,
		mainClassName: PropTypes.string,
		iamLoginRequestInFlight: PropTypes.bool.isRequired,
		iamRequestError: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.bool,
		]),
		userActions: PropTypes.object.isRequired,
		iamThunk: PropTypes.object.isRequired,
		// HOCs
		intl: PropTypes.object.isRequired,
		router: PropTypes.object,
		// Decorators
		errors: PropTypes.object,
		propsFromHost: PropTypes.object,
	};
	static defaultProps = {
		propsFromHost: {},
	};
	constructor(props) {
		super(props);
		/**
		 * Component-specific UI state
		 */
		// Clear existing alerts
		this.state = {
			alertLoginError: false,
		};

		// Register which fields on the page expected validation
		this.validatedFields = [
			'password',
		];
	}
	setEmailFromCookieIfNotAvailableOrRedirectToEmailPage(_hasPreviouslyLoggedIn = hasPreviouslyLoggedIn) {
		const { userActions, emailAddress } = this.props;
		if (!emailAddress || (typeof emailAddress === 'string' && emailAddress.trim().length === 0)) {
			const prevLoggedInDetails = _hasPreviouslyLoggedIn();
			if (prevLoggedInDetails.hasLoggedIn) {
				userActions.updateEmailAddress(prevLoggedInDetails.emailAddress);
			} else {
				this.directToEmailPage();
			}
		}
	}
	componentWillMount() {
		const { userActions } = this.props;
		// Clear password field
		userActions.updatePassword('');

		this.validatedFields.forEach(field => {
			this.hasErrors(field) && this.clearValidation(field);
		});
		this.setEmailFromCookieIfNotAvailableOrRedirectToEmailPage();
	}
	componentDidMount() {
		const { propsFromHost } = this.props;

		if (propsFromHost.onPasswordPageMount) {
			propsFromHost.onPasswordPageMount();
		}
	}
	handlePasswordBlur(e) {
		this.validate('password', e.target.value);
	}
	handlePasswordChange(e) {
		const { userActions } = this.props;
		userActions.updatePassword(e.target.value);
	}
	handleContinue() {
		const { password, propsFromHost } = this.props;

		if (propsFromHost.onPasswordPageSubmitClicked) {
			propsFromHost.onPasswordPageSubmitClicked();
		}

		this.isValid('password', password) && this.proceed();
	}
	directToEmailPage() {
		const { updateRoute, router, publicPath } = this.props;
		setRoute(updateRoute, router)(path.join(publicPath, 'email'));
	}
	handleEditEmailAddressClick(e) {
		e.preventDefault();
		this.directToEmailPage();
	}
	handleFacebookLoginClick(e) {
		e.preventDefault();
		this.directToEmailPage();
	}
	getDefaultHeading1() {
		const { intl, firstName } = this.props;
		return (`${intl.formatMessage('content|login:password|defaultHeading1') }${firstName ? ' ' + firstName : ''}`);
	}
	proceed() {
		const { requestSettings, iamThunk, loginSuccessCallback } = this.props;
		// Clear existing alerts
		this.state = {
			alertLoginError: false,
		};
		iamThunk.iamJgLogin(requestSettings)
			.then(loginSuccessCallback)
			.catch(error => {
				// Enable alerts
				this.setState({
					alertLoginError: true,
				});
			});
	}
	render() {
		const {
			intl,
			passwordPageHeading1,
			password,
			errors,
			emailAddress,
			mainClassName,
			iamLoginRequestInFlight,
			passwordPageContinueButtonLabel,
			globalAlertsDecoratorClass,
			isAppDisabled,
			iamRequestError,
		} = this.props;

		const {
			alertLoginError,
		} = this.state;

		const isFormButtonDisabled = !::this.isEveryValid() || isAppDisabled || iamLoginRequestInFlight;

		return (
			<PageBoilerplateDefault
				intl={intl}
				globalAlertsDecoratorClass={globalAlertsDecoratorClass}
				HeadingH1Content={`${passwordPageHeading1 ? passwordPageHeading1 : ::this.getDefaultHeading1()}`}
				mainClassName={mainClassName}
				isRecoverableError={alertLoginError && iamRequestError}
				handleSubmit={::this.handleContinue}>

				<Avatar />

				{ emailAddress &&
					<div className='login-text-user-email dna-text-center'>
						<span data-qa='returningUserEmailAddress'>{ emailAddress }</span> <br/>
						{ intl.formatMessage('content|login:password|correctEmailAddressMessage') }&nbsp;
						<a
							data-qa='editEmailAddressLink'
							className='dna-text-link'
							onClick={::this.handleEditEmailAddressClick}>
							{ intl.formatMessage('content|login:password|editEmailAddressButtonLabel') }
						</a>
					</div>
				}

				<DNAInputWithLabel
					parent={this}
					errorKey='password'
					handleBlur={::this.handlePasswordBlur}
					handleChangeProp={::this.handlePasswordChange}
					type='password'
					isPasswordField={true}
					value={password}
					toggleButtonTextHide={intl.formatMessage('content|login:password|passwordFieldHintLabelHide')}
					toggleButtonTextShow={intl.formatMessage('content|login:password|passwordFieldHintLabelShow')}
					id='password'
					label={intl.formatMessage('content|login:password|passwordFieldLabel')}
					sizeVariant='medium'
					errors={errors.password} />

				<DNAValidationMessage
					wrapperClass='login-validation-message'
					intl={intl}
					errors={[...errors.password || []]} />

				<p className='login-hint-text-forgot-password dna-text-s-lite'>
					{ intl.formatMessage('content|login:password|forgotPasswordMessage') }&nbsp;
					<a
						data-qa='resetPasswordLink'
						className='dna-text-link dna-text-s'
						href={config.resetPasswordLink}
						target='_blank' >
						{ intl.formatMessage('content|login:password|resetPasswordMessage') }
					</a>
					&nbsp; { intl.formatMessage('content|_defaults|or') }&nbsp;
					<a
						data-qa='fbLoginLink'
						className='dna-text-link dna-text-s'
						onClick={::this.handleFacebookLoginClick}>
						{ intl.formatMessage('content|login:password|loginWithFacebookMessage') }
					</a>
				</p>
				<DNAButtonDefault
					intl={intl}
					decoratorClass='dna-button-brand dna-space-mtm'
					buttonState={iamLoginRequestInFlight ? 'loading' : ''}
					showDisabled={isFormButtonDisabled}
					isDisabled={isFormButtonDisabled}
					qaSelector='PasswordPageContinueButton'
					handleClick={::this.handleContinue}>
					{ passwordPageContinueButtonLabel ? passwordPageContinueButtonLabel :
						intl.formatMessage('content|login:password|defaultContinueButtonLabel')}
				</DNAButtonDefault>

			</PageBoilerplateDefault>
		);
	}
}

export const mapStateToProps = state => {
	const iamLoginRequestInFlight = state.HTTP_request.iam_jg_login && state.HTTP_request.iam_jg_login.isInflight ? true : false;
	return {
		iamLoginRequestInFlight,
		firstName: state.firstName || '',
		emailAddress: state.emailAddress || '',
		password: state.password || '',
		errors: state.VALIDATION_errors || {},
		iamRequestError: getRecoverableErrorType(state, 'iam_jg_login', state.APP_network),
		propsFromHost: state.propsFromHost,
	};
};

const mapDispatchToProps = dispatch => ({
	userActions: bindActionCreators(userActions, dispatch),
	appActions: bindActionCreators(appActions, dispatch),
	validationActions: bindActionCreators(validationActions, dispatch),
	iamThunk: bindActionCreators(iamThunk, dispatch),
});

const PasswordPageComposed = Intl(PasswordPage);
export const PasswordPageWithRouter = connect(mapStateToProps, mapDispatchToProps)(withRouter(PasswordPageComposed));
export default connect(mapStateToProps, mapDispatchToProps)(PasswordPageComposed);



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/containers/pages/PasswordPage.js